import Axios from "axios";

import {
    getIncourseDataAdmin,
    getIncourseCandidatesListAdmin,
    submitIncoursebyAdmin,
    getIncourseWantingListAdmin,
    cancelIncourseSubmissionbyAdmin,
    getIncourseMarksAdmin,
    removePaperFromPL,
    addPaperOnPL,
} from "../../api";
import {
    SET_GET_INCOURSE_DATA_ADMIN,
    UNSET_GET_INCOURSE_DATA_ADMIN,
    GET_INCOURSE_CANDIDATES_LIST_ADMIN,
    GET_INCOURSE_WANTING_LIST_ADMIN,
    GET_INCOURSE_MARKS_ADMIN,
} from "../../mutation-types";
import { add, remove } from "lodash";
const state = {
    incourse_data: [],
    incourse_candidates_list: {},
    incourse_wanting_list: {},
    incourse_marks: [],
};

const getters = {
    getIncourseDataAdmin(state) {
        return state.incourse_data;
    },
    getIncourseCandidatesListAdmin(state) {
        return state.incourse_candidates_list;
    },
    getIncourseWantingListAdmin(state) {
        return state.incourse_wanting_list;
    },
    getIncourseMarksAdmin(state) {
        return state.incourse_marks;
    },

};

const mutations = {
    [SET_GET_INCOURSE_DATA_ADMIN](state, data) {
        return (state.incourse_data = data);
    },
    [UNSET_GET_INCOURSE_DATA_ADMIN](state, data) {
        return (state.incourse_data = []);
    },
    [GET_INCOURSE_CANDIDATES_LIST_ADMIN](state, data) {
        return (state.incourse_candidates_list = data);
    },
    [GET_INCOURSE_WANTING_LIST_ADMIN](state, data) {
        return (state.incourse_wanting_list = data);
    },
    [GET_INCOURSE_MARKS_ADMIN](state, data) {
        return (state.incourse_marks = data);
    },
};

const actions = {
    searchIncourseDataAdmin({ commit }, searchParam) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            Axios.get(getIncourseDataAdmin, { params: searchParam })
                .then((response) => {
                    commit("UNSET_LOADING");
                    const result = response.data.data;
                    console.log("DA... : ", response.data.data);

                    if (response.data.status === "success") {
                        commit("UNSET_GET_INCOURSE_DATA_ADMIN");
                        commit("SET_GET_INCOURSE_DATA_ADMIN", result);
                        resolve(result);
                    } else {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message || "Submission failed",
                            color: "red",
                        });
                        reject(new Error(response.data.message || "Submission failed"));
                    }
                })
                .catch((error) => {
                    commit("UNSET_LOADING");
                    const errorMessage =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        "Server error";
                    commit("SET_SNACKBAR", { msg: errorMessage, color: "red" });
                    reject(new Error(errorMessage));
                });
        });
    },

    resetIncourseDataAdmin({ commit }) {
        commit("UNSET_GET_INCOURSE_DATA_ADMIN");
    },

    fetchIncourseCandidatesListAdmin({ commit }, searchParam) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            const config = {
                params: searchParam,
            };
            if (
                searchParam.display_type === "export_pdf" ||
                searchParam.display_type === "export_xl"
            ) {
                config.responseType = "blob";
            }
            Axios.get(getIncourseCandidatesListAdmin, config)
                .then(function (response) {
                    commit("UNSET_LOADING");
                    if (!searchParam.display_type) {
                        const result = response.data.data;
                        commit("GET_INCOURSE_CANDIDATES_LIST_ADMIN", result);
                        resolve(response.data);
                    }
                    if (searchParam.display_type === "export_pdf") {
                        const contentType = response.headers["content-type"];
                        if (contentType !== "application/pdf") {
                            const reader = new FileReader();
                            reader.onload = function () {
                                try {
                                    const parsed = JSON.parse(reader.result);
                                    commit("SET_SNACKBAR", {
                                        msg: parsed.message || "PDF generation failed",
                                        color: "red",
                                    });
                                    reject(parsed);
                                } catch (e) {
                                    commit("SET_SNACKBAR", {
                                        msg: "Unexpected response from server",
                                        color: "red",
                                    });
                                    reject(e);
                                }
                            };
                            reader.readAsText(response.data);
                            return;
                        }
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        if (searchParam.confirm_status == 1 && searchParam.display_type == "export_xl") {
                            link.download =
                                "incourse_marks_" +
                                searchParam.exam_code +
                                "_" +
                                searchParam.exam_year +
                                "_" +
                                searchParam.college_code +
                                "_" +
                                searchParam.subject_code +
                                ".pdf";
                        } else {
                            "incourse_candidates_" +
                                searchParam.exam_code +
                                "_" +
                                searchParam.exam_year +
                                "_" +
                                searchParam.college_code +
                                "_" +
                                searchParam.subject_code +
                                ".pdf";
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        resolve(response);
                        return;
                    }
                    if (searchParam.display_type === "export_xl") {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        if (searchParam.confirm_status == 1 && searchParam.display_type == "export_xl") {
                            link.download =
                                "incourse_marks_" +
                                searchParam.exam_code +
                                "_" +
                                searchParam.exam_year +
                                "_" +
                                searchParam.college_code +
                                "_" +
                                searchParam.subject_code +
                                ".xlsx";
                        } else {
                            link.download =
                                "incourse_candidates_" +
                                searchParam.exam_code +
                                "_" +
                                searchParam.exam_year +
                                "_" +
                                searchParam.college_code +
                                "_" +
                                searchParam.subject_code +
                                ".xlsx";
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        resolve(response);
                        return;
                    }
                })
                .catch(function (error) {
                    commit("UNSET_LOADING");
                    var msg =
                        (error &&
                            error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        "Server error";
                    commit("SET_SNACKBAR", {
                        msg: msg,
                        color: "red",
                    });
                    reject(error);
                });
        });

    },

    submitIncoursebyAdmin: ({ commit }, payload) => {
        commit("SET_LOADING", {
            color: "primary"
        });

        return new Promise((resolve, reject) => {
            Axios.post(submitIncoursebyAdmin, payload)

                .then(response => {
                    if (response.data.status == 'success') {
                        commit("UNSET_GET_INCOURSE_DATA_ADMIN");
                        commit("SET_SNACKBAR", {
                            msg: response.data.message || "Marks submitted successfully",
                            color: "green"
                        });
                        resolve(response);
                    } else {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message || "Submission failed",
                            color: "red"
                        });
                        reject(new Error(response.data.message || "Submission failed"));
                    }
                })

                .catch(error => {

                    let msg = "Submission failed";

                    if (
                        error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                    ) {
                        msg = error.response.data.message;
                    }

                    commit("SET_SNACKBAR", {
                        msg: msg,
                        color: "red"
                    });

                    commit("SET_RETURN_MESSAGE", msg);

                    reject(error);
                })

                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    fetchIncourseWantingList({ commit }, searchParam) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            const config = {
                params: searchParam,
            };
            if (
                searchParam.display_type === "export_pdf" ||
                searchParam.display_type === "export_xl"
            ) {
                config.responseType = "blob";
            }
            Axios.get(getIncourseWantingListAdmin, config)
                .then(function (response) {
                    commit("UNSET_LOADING");
                    if (!searchParam.display_type) {
                        const result = response.data.data;
                        commit("GET_INCOURSE_WANTING_LIST_ADMIN", result);
                        resolve(response.data);
                    }
                    if (searchParam.display_type === "export_pdf") {
                        const contentType = response.headers["content-type"];
                        if (contentType !== "application/pdf") {
                            const reader = new FileReader();
                            reader.onload = () => {
                                const text = reader.result;
                                const parsed = JSON.parse(text);
                                commit("SET_SNACKBAR", {
                                    msg: parsed.message || "Unexpected response",
                                    color: "red",
                                });
                                reject();
                            };
                            reader.readAsText(response.data);
                            return;
                        }
                        resolve(response.data);
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        if (searchParam.display_type == "export_pdf") {
                            link.download =
                                "incourse_wanting_" +
                                searchParam.exam_code +
                                "_" +
                                searchParam.exam_year +
                                ".pdf";
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        return;
                    }

                    if (searchParam.display_type === "export_xl") {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        if (searchParam.display_type == "export_xl") {
                            link.download =
                                "incourse_wanting_" +
                                searchParam.exam_code +
                                "_" +
                                searchParam.exam_year +
                                ".xlsx";
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        resolve(response);
                        return;
                    }
                })
                .catch(function (error) {
                    commit("UNSET_LOADING");
                    var msg =
                        (error &&
                            error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        "Server error";
                    commit("SET_SNACKBAR", {
                        msg: msg,
                        color: "red",
                    });
                    reject(error);
                });
        });

    },

    fetchIncourseMarksAdmin({ commit }, searchParam) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            Axios.get(getIncourseMarksAdmin, { params: searchParam })
                .then((response) => {
                    commit("UNSET_LOADING");
                    const result = response.data.data;
                    console.log("Tanvir... : ", response.data.data);

                    if (response.data.status === "success") {
                        commit("GET_INCOURSE_MARKS_ADMIN", result);
                        resolve(result);
                    } else {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message || "Data fetch failed",
                            color: "red",
                        });
                        reject(new Error(response.data.message || "Data fetch failed"));
                    }
                })
                .catch((error) => {
                    commit("UNSET_LOADING");
                    const errorMessage =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        "Server error";
                    commit("SET_SNACKBAR", { msg: errorMessage, color: "red" });
                    reject(new Error(errorMessage));
                });
        });
    },

    cancelIncourseSubmissionbyAdmin: ({ commit }, payload) => {
        commit("SET_LOADING", {
            color: "primary"
        });
        return new Promise((resolve, reject) => {
            Axios.get(cancelIncourseSubmissionbyAdmin, { params: payload })
                .then(response => {
                    if (response.data.status == 'success') {
                        commit("UNSET_GET_INCOURSE_DATA_ADMIN");
                        commit("SET_SNACKBAR", {
                            msg: response.data.message || "Submission cancelled successfully",
                            color: "green"
                        });
                        resolve(response);
                    } else {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message || "Cancellation failed",
                            color: "red"
                        });
                        reject(new Error(response.data.message || "Cancellation failed"));
                    }
                })
                .catch(error => {
                    let msg = "Cancellation failed";
                    if (
                        error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                    ) {
                        msg = error.response.data.message;
                    }
                    commit("SET_SNACKBAR", {
                        msg: msg,
                        color: "red"
                    });
                    commit("SET_RETURN_MESSAGE", msg);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    addPaperOnPL: ({ commit }, payload) => {
        commit("SET_LOADING", {
            color: "primary"
        });
        return new Promise((resolve, reject) => {
            Axios.post(addPaperOnPL, payload)
                .then(response => {
                    if (response.data.status == 'success') {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message || "Paper added on PL successfully",
                            color: "green"
                        });
                        resolve(response);
                    } else {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message || "Failed to add paper on PL",
                            color: "red"
                        });
                        reject(new Error(response.data.message || "Failed to add paper on PL"));
                    }
                })
                .catch(error => {
                    let msg = "Failed to add paper on PL";
                    if (
                        error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                    ) {
                        msg = error.response.data.message;
                    }
                    commit("SET_SNACKBAR", {
                        msg: msg,
                        color: "red"
                    });
                    commit("SET_RETURN_MESSAGE", msg);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    removePaperFromPL: ({ commit }, payload) => {
        commit("SET_LOADING", {
            color: "primary"
        });
        return new Promise((resolve, reject) => {
            Axios.delete(removePaperFromPL, { data: payload })
                .then(response => {
                    if (response.data.status == 'success') {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message || "Paper removed from PL successfully",
                            color: "green"
                        });
                        resolve(response);
                    } else {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message || "Failed to remove paper from PL",
                            color: "red"
                        });
                        reject(new Error(response.data.message || "Failed to remove paper from PL"));
                    }
                })
                .catch(error => {
                    let msg = "Failed to remove paper from PL";
                    if (
                        error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                    ) {
                        msg = error.response.data.message;
                    }
                    commit("SET_SNACKBAR", {
                        msg: msg,
                        color: "red"
                    });
                    commit("SET_RETURN_MESSAGE", msg);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

};

export default {
    state,
    getters,
    actions,
    mutations
};
